export default __webpack_public_path__ + "static/media/84.ea6fcd54.jpg";